import { r as i, h as t, H as a } from "./main-bb89b2f2.js";
import { $ as r } from "./screen.store-835df690-461bc8b5.js";
import "vue";
import "./toNumber-f405d8e0-e5c83f11.js";
const n = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.block{display:block}.flex{display:flex}:host{display:block}.menu-flyout-separator{align-items:center;box-sizing:border-box;display:flex;justify-content:center;padding:10px 24px;width:auto}.menu-flyout-separator div{background-color:var(--color-steel-300);box-sizing:border-box;height:1px;width:100%}.static{position:static}", s = n, l = class {
  constructor(e) {
    i(this, e), this.headerFirstRow = !1;
  }
  render() {
    const e = {
      "menu-flyout-separator": !0
    }, o = this.headerFirstRow ? r.smAndDown : r.lgAndDown;
    return t(a, { key: "752d2ea0f28e8ad9d2fee85099e56a40ca1a76e3" }, !o && t("div", { key: "54b9ebaed82de9fa29d7893cf7c89edb3b5cb581", class: e }, t("div", { key: "da85a0ec3b217df68ce913874331189a63f04e27" })));
  }
};
l.style = s;
export {
  l as patternlib_menu_flyout_separator
};
